import { useEffect } from "react";
import { frontDB } from "../../../../../frontDB";
import { useEmails } from "../../useEmails";
import styles from "./EmailsHeader.module.css";
import { useEmailsHeader } from "./useEmailsHeader";
import CloseIcon from "@rsuite/icons/Close";
import {
  Button,
  Input,
  InputGroup,
  InputPicker,
  IconButton,
  DatePicker,
} from "rsuite";

import {
  showActive,
  getResponsibleName,
  filterUsers,
} from "../../../../../helperFunctions";
import {
  invoiceStatus,
  invoiceDepartments,
} from "../../../../Settings/Data/lists";

function EmailsHeader() {
 
  let {
    filter,

    statusHandler,
    searchInputHandler,
    periodFromHandler,
    periodToHandler,

    searchValues,
    searchClearHandler,
  } = useEmailsHeader();

  useEffect(() => {
    //getWorkOrdersStatsByAllLocations();
  }, []);

  let { users} = frontDB();
  let userFilter = {
    location: "659a601d38d14accc6a6b0ec",
    status: "Active",
    responsible: "All responsibles",
  };
  let officeUsers = filterUsers(userFilter, users).map((item) => ({
    label: `${item.name}`,
    value: item._id,
  }));

  const responsibleName = getResponsibleName();

  const emailStatusOptions = [
    { label: "All statuses", value: "*" },
    { label: "Created", value: "invoicesCreated" },
    { label: "No Invoice", value: "noInvoice" },
    { label: "Error", value: "createInvoiceError" },
  ];

  return (
    <>
      <div className={styles.invoices_header}>
        <div className={styles.invoices_header_title}>Invoice Emails</div>

        <div className={styles.invoices_header_options}>
          <InputPicker
            value={filter?.status}
            onChange={statusHandler}
            cleanable={false}
            placeholder="Select Status"
            data={emailStatusOptions}
            style={{ width: 185 }}
          />

          <div className={styles.date_pickers_container}>
            <DatePicker
              oneTap
              value={new Date(filter.from)}
              onChange={periodFromHandler}
              isoWeek
              cleanable={false}
              format="dd/MM/yyyy"
              appearance="default"
              placeholder="From"
              style={{ width: 163 }}
            />

            <DatePicker
              oneTap
              value={new Date(filter.to)}
              onChange={periodToHandler}
              isoWeek
              cleanable={false}
              format="dd/MM/yyyy"
              appearance="default"
              placeholder="To"
              style={{ width: 160 }}
            />
          </div>
        </div>
   
    
        <InputGroup inside style={{ width: "185px" }}>
          <Input
            value={searchValues?.company}
            className={styles.search_input}
            id="company"
            onChange={searchInputHandler}
            placeholder="Search by company"
          />

          {searchValues?.company && (
            <InputGroup.Button
              id="company"
              onClick={() => searchClearHandler("company")}
            >
              <CloseIcon />
            </InputGroup.Button>
          )}
        </InputGroup>
        <InputGroup inside style={{ width: "160px" }}>
          <Input
            value={searchValues?.invoiceNumber}
            className={styles.search_input}
            id="invoiceNumber"
            onChange={searchInputHandler}
            placeholder="Invoice or PO"
          />
          {searchValues?.invoiceNumber && (
            <InputGroup.Button
              onClick={() => searchClearHandler("invoiceNumber")}
            >
              <CloseIcon />
            </InputGroup.Button>
          )}
        </InputGroup>

        <div>
          <div style={{ fontSize: 12 }}>Errors: na</div>{" "}
        </div>
      </div>
    </>
  );
}

export default EmailsHeader;
